// extracted by mini-css-extract-plugin
module.exports = {"slideItems":"CoverSlider_slideItems__hGdoU","keyVisualImage":"CoverSlider_keyVisualImage__InzAg","single":"CoverSlider_single__wZrqs","slideDot":"CoverSlider_slideDot__eN43Y"};